﻿import { Outlet, Link } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import { Shield } from 'lucide-react';

export function CheckoutLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <header className="sticky top-0 z-40 border-b border-border bg-white">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Link to={ROUTES.HOME} className="text-xl font-bold tracking-tight text-text-primary">
            Beauty<span className="text-accent"> Sports</span>
          </Link>
          <div className="flex items-center gap-2 text-sm text-text-muted">
            <Shield className="h-4 w-4 text-success" />
            <span>Secure Checkout</span>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
      <footer className="border-t border-border bg-white py-4 text-center text-sm text-text-muted">
        © {new Date().getFullYear()} Beauty Sports. All rights reserved.
      </footer>
    </div>
  );
}




